import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { environment } from '~env';
import { MemberSubscriptionFee } from './member-subscriptionfeee.model';


const API_URL = environment.registrarQueryApi;

@Injectable({
  providedIn: 'root',
})
export class MemberSubscriptionFeeQueryService {
  constructor(private http: HttpClient, private translate: TranslateService,) { }


  getMemberSubscriptionFees(memberId: string, isResubscription: boolean, year: number, validFrom: Date, validTo: Date, donationAmount: number) {
    return this.http
      .get(`${API_URL}/member/${memberId}/subscriptionFees?isReSubscription=${isResubscription}&period=${year}&validFromDate=${validFrom.toISOString()}&validToDate=${validTo.toISOString()}`).pipe(
        map((res: any) => this.parseMemberSubscriptionFees(res, donationAmount)))
  }

  private parseMemberSubscriptionFees(item: any, donationAmount: number) {
    let memberSubscriptionFees: MemberSubscriptionFee[] = [];

    if (item.subscriptionFeeType != null && item.subscriptionFeeType != undefined) {
      memberSubscriptionFees.push({
        id: item.subscriptionFeeType.id,
        code: item.subscriptionFeeType.code,
        feeTypeLabel:
        {
          fr: item.subscriptionFeeType.descriptionFr,
          en: item.subscriptionFeeType.descriptionEn
        },
        amount: item.subscriptionFeeType.amount,
        tpsAmount: item.subscriptionFeeType.tpsAmount,
        tvqAmount: item.subscriptionFeeType.tvqAmount,
        billDate: item.subscriptionFeeType.effectiveOn,
        isPayingAsFormerPresidentOrHonorificMember: item.isPayingAsFormerPresidentOrHonorificMember
      });
    }

    if (item.opqFeeType != null && item.opqFeeType != undefined) {
      memberSubscriptionFees.push({
        id: item.opqFeeType.id,
        code: item.opqFeeType.code,
        feeTypeLabel:
        {
          fr: item.opqFeeType.descriptionFr,
          en: item.opqFeeType.descriptionEn
        },
        amount: item.opqFeeType.amount,
        tpsAmount: item.opqFeeType.tpsAmount,
        tvqAmount: item.opqFeeType.tvqAmount,
        billDate: item.opqFeeType.effectiveOn,
        isPayingAsFormerPresidentOrHonorificMember: item.isPayingAsFormerPresidentOrHonorificMember
      });
    }

    if (item.fonFeeType != null && item.fonFeeType != undefined) {
      memberSubscriptionFees.push({
        id: item.fonFeeType.id,
        code: item.fonFeeType.code,
        feeTypeLabel:
        {
          fr: item.fonFeeType.descriptionFr,
          en: item.fonFeeType.descriptionEn
        },
        amount: item.fonFeeType.amount,
        tpsAmount: item.fonFeeType.tpsAmount,
        tvqAmount: item.fonFeeType.tvqAmount,
        billDate: item.fonFeeType.effectiveOn,
        isPayingAsFormerPresidentOrHonorificMember: item.isPayingAsFormerPresidentOrHonorificMember
      });
    }

    if (item.lateFeeType != null && item.lateFeeType != undefined) {
      memberSubscriptionFees.push({
        id: item.lateFeeType.id,
        code: item.lateFeeType.code,
        feeTypeLabel:
        {
          fr: item.lateFeeType.descriptionFr,
          en: item.lateFeeType.descriptionEn
        },
        amount: item.lateFeeType.amount,
        tpsAmount: item.lateFeeType.tpsAmount,
        tvqAmount: item.lateFeeType.tvqAmount,
        billDate: item.lateFeeType.effectiveOn,
        isPayingAsFormerPresidentOrHonorificMember: item.isPayingAsFormerPresidentOrHonorificMember
      });
    }

    if (item.reInscriptionFeeType != null && item.reInscriptionFeeType != undefined) {
      memberSubscriptionFees.push({
        id: item.reInscriptionFeeType.id,
        code: item.reInscriptionFeeType.code,
        feeTypeLabel:
        {
          fr: item.reInscriptionFeeType.descriptionFr,
          en: item.reInscriptionFeeType.descriptionEn
        },
        amount: item.reInscriptionFeeType.amount,
        tpsAmount: item.reInscriptionFeeType.tpsAmount,
        tvqAmount: item.reInscriptionFeeType.tvqAmount,
        billDate: item.reInscriptionFeeType.effectiveOn,
        isPayingAsFormerPresidentOrHonorificMember: item.isPayingAsFormerPresidentOrHonorificMember
      });
    }
    if(item.otherFeeType != null && item.otherFeeType != undefined){
      item.otherFeeType.forEach(element => {
        memberSubscriptionFees.push({
          id: element.id,
          code: element.code,
          feeTypeLabel:
          {
            fr: element.descriptionFr,
            en: element.descriptionEn
          },
          amount: element.amount + element.tpsAmount + element.tvqAmount,
          tpsAmount: 0,
          tvqAmount: 0,
          billDate: element.effectiveOn,
          isPayingAsFormerPresidentOrHonorificMember: item.isPayingAsFormerPresidentOrHonorificMember,
          isUnpaidBillType: true
        });
      });
    }

    if(donationAmount > 0)
      // Voluntary Contribution
      memberSubscriptionFees.push({
        id: "",
        code: '',
        feeTypeLabel: {
          fr: this.translate.instant('inscription.form.payment.foundationDonation'),
          en: this.translate.instant('inscription.form.payment.foundationDonation'),
        },
        amount: donationAmount,
        tpsAmount: 0,
        tvqAmount: 0,
        billDate: new Date(),
        isPayingAsFormerPresidentOrHonorificMember: item.isPayingAsFormerPresidentOrHonorificMember
      })

    return memberSubscriptionFees;
  }
}